module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc38-9813321c7ff124fdd291b193ad7254f7.jpg";